import { Guid } from 'guid-typescript';

export enum SampleHistory {
  Natural = 'Natural State',
  AirDried = 'Air-Dried',
  OvenDried = 'Oven-Dried',
  Unknown = 'Unknown',
}

export enum WashingMethod {
  Standard = 'Standard',
  Alternative = 'Alternative',
}

export enum MaterialConditionAsTested {
  Natural = 'Natural State',
  Rubbed = 'Rubbed through sieve',
}

export enum PreparationMethod {
  Wet = 'Wet',
  Dry = 'Dry',
  Alternative = 'Alternative',
}

export enum MaterialDriedBy {
  Air = 'Air Drying',
  Oven = 'Oven Drying',
}

export enum OversizeMaterialRemovedBy {
  Mortar_Pestle = 'Mortar and Pestle',
  Mechanical = 'Mechanical Device',
}

export enum RolledBy {
  Hand = 'Hand',
  GlassPlates = 'Between two glass plates',
}

export enum MaterialSuitability {
  MaterialSuitable = 'MaterialSuitable',
  NotTested = 'NotTested_LLCouldNotBeObtained',
  ResultNotDetermined = 'ResultCannotBeDetermined',
}

export type LiquidLimitSpecimen = {
  /**
   * Index of the specimen - relative to it's position in the grid
   */
  Index: number;
  /**
   * UUID of the specimen
   */
  TrialId: Guid;
  /**
   * Flag value indicating that the specimen is suitable for shrinkage
   */
  SuitableForShrinkage: boolean;
  /**
   * Flag value indicating that the trial was excluded
   */
  ExcludedTrial: boolean;
};
